export function itemImage(item) {
  return item?.itemInfo?.imageUrl || item?.bundleGroup?.heroImageUrl || "/images/Android.png";
}

export function itemSubtitle(item) {
  const info = item?.itemInfo || {};
  if (item?.serviceType === "flights") {
    const journeys = Array.isArray(info.journeys) ? info.journeys : [];
    return journeys
      .map((journey) => {
        const flights = Array.isArray(journey?.flights) ? journey.flights : [];
        const first = flights[0];
        const last = flights[flights.length - 1];
        return first && last ? `${first.departure?.airport || ""} → ${last.arrival?.airport || ""}` : "Flight itinerary";
      })
      .filter(Boolean)
      .join(" · ");
  }
  if (item?.serviceType === "esim") {
    return [info.locationCode, info.volumeInGB ? `${info.volumeInGB}GB` : null, info.duration ? `${info.duration} days` : null]
      .filter(Boolean)
      .join(" · ");
  }
  if (item?.serviceType === "airportLounge") {
    return [info.airport || info.airportIata, info.terminal, info.guests ? `${info.guests} guest${info.guests === 1 ? "" : "s"}` : null]
      .filter(Boolean)
      .join(" · ");
  }
  return [info.packageName || info.packageOptionName, info.visitDate || info.slotDate]
    .filter(Boolean)
    .join(" · ");
}

export function displayPrice(item) {
  const displayValue = item?.displayPrice || item?.displayPriceBeforeTierDiscount || item?.displayOriginalPrice;
  if (displayValue) {
    const currency = String(item?.currency || "").trim();
    const text = String(displayValue).trim();
    return currency && !text.toUpperCase().startsWith(currency.toUpperCase())
      ? `${currency} ${text}`
      : text;
  }
  return `${item?.currency || ""} ${Number(item?.price || 0).toFixed(2)}`.trim();
}

export function displayCheckoutTotal(priceInfo) {
  return priceInfo?.totalPrice?.content || priceInfo?.displayTotal || priceInfo?.displayFinalAmount || "—";
}
